/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { UserDto } from './user-dto';

/**
 * 
 * @export
 * @interface PaginatedSubmissionsDto
 */
export interface PaginatedSubmissionsDto {
    /**
     * Submission ID
     * @type {string}
     * @memberof PaginatedSubmissionsDto
     */
    'id': string;
    /**
     * Creation date in UTC
     * @type {string}
     * @memberof PaginatedSubmissionsDto
     */
    'createdAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof PaginatedSubmissionsDto
     */
    'updatedAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof PaginatedSubmissionsDto
     */
    'deletedAt': string;
    /**
     * Activity ID
     * @type {string}
     * @memberof PaginatedSubmissionsDto
     */
    'activityId': string;
    /**
     * Challenge category participation ID
     * @type {string}
     * @memberof PaginatedSubmissionsDto
     */
    'participationId': string;
    /**
     * Submission approval status
     * @type {string}
     * @memberof PaginatedSubmissionsDto
     */
    'status': PaginatedSubmissionsDtoStatusEnum;
    /**
     * Reason for decline (only when status is declined)
     * @type {string}
     * @memberof PaginatedSubmissionsDto
     */
    'declineReason'?: string;
    /**
     * User details
     * @type {UserDto}
     * @memberof PaginatedSubmissionsDto
     */
    'user'?: UserDto;
    /**
     * Image URL
     * @type {Array<string>}
     * @memberof PaginatedSubmissionsDto
     */
    'imageUrls'?: Array<string>;
    /**
     * Activity distance
     * @type {number}
     * @memberof PaginatedSubmissionsDto
     */
    'activityDistance'?: number;
}

export const PaginatedSubmissionsDtoStatusEnum = {
    Pending: 'pending',
    Approved: 'approved',
    Declined: 'declined'
} as const;

export type PaginatedSubmissionsDtoStatusEnum = typeof PaginatedSubmissionsDtoStatusEnum[keyof typeof PaginatedSubmissionsDtoStatusEnum];


